import httpService from '../Api/http.service';
import { getApiBaseUrl } from 'utils';

const getAppCoreBaseUrl = () => `${getApiBaseUrl()}/appcore`;

const createAffiliate = (payload) =>
  httpService({
    url: `${getAppCoreBaseUrl()}/affiliates`,
    method: 'post',
    data: payload,
  });

const getAffiliates = (paramsObj) =>
  httpService({
    url: `${getAppCoreBaseUrl()}/affiliates`,
    method: 'get',
    params: paramsObj,
  });

const getAffiliateById = (affiliateId) =>
  httpService({
    url: `${getAppCoreBaseUrl()}/affiliates/${affiliateId}`,
    method: 'get',
  });

const updateAffiliate = (affiliateId, payload) =>
  httpService({
    url: `${getAppCoreBaseUrl()}/affiliates/${affiliateId}`,
    method: 'patch',
    data: payload,
  });

const addCode = (affiliateId, payload) =>
  httpService({
    url: `${getAppCoreBaseUrl()}/affiliates/${affiliateId}/codes`,
    method: 'post',
    data: payload,
  });

const updateCode = (affiliateId, codeId, payload) =>
  httpService({
    url: `${getAppCoreBaseUrl()}/affiliates/${affiliateId}/codes/${codeId}`,
    method: 'patch',
    data: payload,
  });

const attachAssociation = (affiliateId, payload) =>
  httpService({
    url: `${getAppCoreBaseUrl()}/affiliates/${affiliateId}/associations`,
    method: 'post',
    data: payload,
  });

const detachAssociation = (affiliateId, codeId, level, levelId) =>
  httpService({
    url: `${getAppCoreBaseUrl()}/affiliates/${affiliateId}/associations/${codeId}/${level}/${levelId}`,
    method: 'delete',
  });

const affiliateService = {
  createAffiliate,
  getAffiliates,
  getAffiliateById,
  updateAffiliate,
  addCode,
  updateCode,
  attachAssociation,
  detachAssociation,
};

export default affiliateService;
